import { finish, error } from '../../../modules/reports/actions/email';

import api from '../../../api';

export function request(dispatch, { documentId, reportType }) {

    api.post(`/reports/email/${documentId}`, void 0, { documentId, cache: true }).then(
        (data) => dispatch(finish(documentId, data)),
        ({ errors }) => dispatch(error(documentId, errors))
    );
}
